// extracted by mini-css-extract-plugin
export var pillWrapper = "_py-0";
export var showOverflow = "_py-1";